// extracted by mini-css-extract-plugin
export default {"readOnlyContainer":"TextFieldComponent_readOnlyContainer__7QhdX","label":"TextFieldComponent_label__Q9ZwM","content":"TextFieldComponent_content__ffexC"};